import { Fragment, useEffect, useRef } from 'react';
import { t, translate } from 'react-switch-lang';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactMarkdown from 'react-markdown';
import { setScreenReaderAlert, moveFocusTo } from '../utils/Accessibility';

function ErrorAlert({ msg, fullWidth, forgotPassword, children }) {
  const msgRef = useRef();
  useEffect(() => {
    if (!msg) return;
    if (forgotPassword) {
      setScreenReaderAlert(`${msg} ${t('ScreenReaderAlert_ForgotPassword')}`);
    }
    moveFocusTo('error-alert');
  }, [msg]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!msg) return null;
  return (
    <div id="error-alert" className={`alert error${fullWidth ? ' full' : ''}`}>
      <FontAwesomeIcon icon={['fal', 'exclamation-circle']} className="textDanger" />
      <p className="ms-2">
        <span ref={msgRef}>
          <ReactMarkdown
            components={{
              strong: 'b',
              p: ({ node, ...props }) => <Fragment {...props} />,
              a: ({ node, children: anchorChildren, ...props }) => <a {...props} target="_blank" className="mapleLink">{anchorChildren}</a>,
            }}
          >
            {msg}
          </ReactMarkdown>
        </span>
        {children && (
          <>
            <br />
            {children}
          </>
        )}
      </p>
    </div>
  );
}

export default translate(ErrorAlert);
